import TrainingView from './TrainingView';

export default TrainingView;
